import { Box, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { useMeasurementWizardStore } from '@/store/useMeasurementWizardStore';
import { useState } from 'react';

/**
 * AnonymousPatientPanel - Display for anonymous patient (no patient associated)
 * Shows only "Anonymous Patient" with option to change to real patient
 */
export function AnonymousPatientPanel() {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const setPatientPanelMode = useMeasurementWizardStore((s) => s.setPatientPanelMode);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleChangePatient = () => {
    handleMenuClose();
    setPatientPanelMode('selection');
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Patient details</Typography>
        <IconButton onClick={handleMenuOpen} size="small">
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleChangePatient}>Change patient</MenuItem>
        </Menu>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="overline" color="text.secondary">
          Full name
        </Typography>
        <Typography variant="body1">
          Anonymous Patient
        </Typography>
      </Box>
    </Box>
  );
}
